module.exports = __webpack_public_path__ + "static/media/Correct Icon.d0c0e17d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon/Correct Icon.png
// module id = 604
// module chunks = 0